import { get } from 'lodash'
import { type } from './dataType'

const prepareShow = visitor => {
  visitor._type = get(type, visitor.type, visitor.type)
  return visitor
}

const prepareSearch = (search) => {
  search.generic = search.generic
  return search
}

export default {
  prepareShow,
  prepareSearch,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/visitor/index/resources/methods.js